import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import Select from '@material-ui/core/Select';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Menu from '@material-ui/core/Menu';
import Paper from '@material-ui/core/Paper';

import SearchInput from '../Inputs/SearchInput';
import Icon from '../../../Icon';
import Input from '@material-ui/core/Input';

import menuprops from '../../../dropDown/menuProps';

const search_list_container_styles = theme => ({
  container: {
    width:'100%'
  },
  list_container: {
    paddingBottom:0
  },
  content: {
    display:"flex",
    flexDirection:'column',
    flex:1,
    overflow:'auto'
  },
  icon_class_container: {
    marginTop: -2
  },
  root_list_item: {
    cursor: "pointer",
    padding: theme.margins.xs,
    '&:hover': {
      background: theme.palette.lightGrey,
    },
  },
  search_list_item: {
    height:'auto !important',
    padding: theme.margins.xs,
    textAlign:'center',
    '&:hover, &:focus': {
      background: theme.palette.white
    },
  },
  selected: {
    fontWeight: theme.fontWeight.bold,
  },
  input: {
    background: theme.palette.white,
    padding: `0 8px`,
    border:`1px solid ${theme.palette.lightGrey}`,
  },
  paper: {
    borderRadius:0,
    border:`1px solid ${theme.palette.lightGrey}`,
    boxShadow: "0px 4px 5px #eee",
    background:theme.palette.white,
    width:'100%',
    maxWidth: "var(--container-width)",
    [theme.breakpoints.up('sm')]: {
      maxWidth:"var(--container-width-lg)"
    }
  },
  disabled: {},
  focused: {},
  error: {},
  search_input_root: {
    padding:`4px 0`,
    lineHeight:1.5
  },
  underline: {
    '&:before':{
        borderBottom: `1px solid ${theme.palette.lightGrey}`
     },
    '&:hover:not($disabled):not($focused):not($error):before':{
        borderBottomColor: theme.palette.mediumGrey,
     },
    '&:after': {
        borderBottom: `1px solid ${theme.palette.deepGrey}`
     }
  },
  list_container: {
    paddingBottom:0
  },
  add_field: {
    padding:`${theme.spacing_unit.xs/2}px ${theme.margins.xs}px`,
    borderTop:`1px solid ${theme.palette.lightGrey}`,
  },
  label: {
  //  marginTop: 6
  }
})

export const SearchListContainer = ({
  classes,
  default_search_value,
  search_value,

  container_width,
  container_class,

  handleChange,

  has_add_fields,
  add_fields_label,
  add_fields_action,

  input_props = {},
  children,
  onSelect,
  ...other
}) => {

    const [selected_search_value, set_selected_search_value] = React.useState('');
    const [select_ref, set_ref] = React.useState(null);

    function handle_select(e, item) {
       set_selected_search_value(item.name);
       handleChange({ target: { value: '' } }); // clear the selection
       set_ref(null);
       if (typeof onSelect === "function") { onSelect(e, item) }
    }

    function cancel() {
      handleChange({ target: { value: '' } }); // clear the selection
      set_ref(null);
    }

    function invoke_add_fields_action(e) {
      cancel();
      add_fields_action(e);
    }

  return (
    <>
        <FormControl fullWidth>
          <InputLabel
              htmlFor={`${default_search_value}`}
              className = {classes.label}>
            {default_search_value}
          </InputLabel>
          <Select
            open = {false}
            renderValue = {()=>selected_search_value}
            value = {selected_search_value}
            onOpen={(e)=> set_ref(e.currentTarget)}
            input = {
              <Input
                classes = {{
                  input: classes.search_input_root,
                  underline: classes.underline
                }}
              />
            }
          />
        </FormControl>
        <Menu
            anchorEl={select_ref}
            keepMounted
            open={Boolean(select_ref)}
            onClose = {cancel}
            value = {search_value}
            marginThreshold = {0}
            {
              ...menuprops({
                direction:"left",
                style: { maxHeight: 800 }
              })
            }
            MenuListProps = {{
              classes: {
                root: has_add_fields ? classes.list_container : ''
              }
            }}
            style = {{ '--container-width': `${container_width}px` }}
            classes = {{
              paper: classes.paper + (container_class ? ' ' + container_class : '')
            }}
          >
            <MenuItem classes = {{ root: classes.search_list_item }}>
                <FormControl fullWidth>
                    <SearchInput
                      onChange = {handleChange}
                      value = {search_value}
                      className = {`${classes.input} ${(input_props.input_class||'')}`}
                    />
                </FormControl>
            </MenuItem>

            { children ? React.cloneElement(children, { handle_select }) :  null }

            {
              has_add_fields
              ?
              <MenuItem
                className = {classes.add_field}
                onClick = {invoke_add_fields_action}
              >
                {add_fields_label}
              </MenuItem>
              : null
            }
          </Menu>
      </>
  );
}

SearchListContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  input_props: PropTypes.object,
  icon_type: PropTypes.string,
  search_value: PropTypes.string,
  selected_value: PropTypes.string,
  onSelect: PropTypes.func,
  default_search_value: PropTypes.string,
  Container: PropTypes.func
}

SearchListContainer.defaultProps = {
    default_search_value: "Select",
}

export default React.memo(withStyles(search_list_container_styles)(SearchListContainer));
